// extracted by mini-css-extract-plugin
export var aiButtonContainer = "_49-0";
export var orangeButton = "_49-1";